<template>
    <div class="bg-box">
        <top-bar></top-bar>
        <div class="middle">
            <navigation-bar></navigation-bar>
            <middle-content>
                <slot></slot>
            </middle-content>
        </div>
    </div>
</template>

<script>
    import TopBar from "./TopBar.vue";
    import NavigationBar from "./NavigationBar.vue";
    import MiddleContent from "./MiddleContent.vue";

    export default {
        name: "MainLayout",
        components: {
            TopBar,
            NavigationBar,
            MiddleContent,
        },
    };
</script>

<style scoped>
    .bg-box {
        width: calc(100% - 32px);
        height: calc(100% - 32px);
        padding: 16px;
    }
    .middle {
        display: flex;
        margin-top: 16px;
        width: 100%;
        height: calc(100% - 76px);
    }
</style>